export enum AddOn {
  Covid = 1,
  Adventurous = 6,
}
